import { createAsyncThunk } from "@reduxjs/toolkit";

import includes from "lodash/includes";

import { changeSignupFormResponses, getSignupFormResponses } from "@/models";
import { AppState } from "@/redux/store/store";
import { fetchAuthToken } from "@/helpers/fetch-auth-token";

export const fetchSignupFormResponses = createAsyncThunk(
  "signupFormResponses/fetchSignupFormResponses",
  async (_, { getState, rejectWithValue }) => {
    try {
      const { adapter, user, signupFormQuestions } = getState() as AppState;
      const { baseUrl } = adapter.adapter;
      const { profile } = user.registeredUser;
      const { token } = fetchAuthToken(getState());
      const questions = signupFormQuestions.signupFormQuestions;

      const questionIdAndTypesOfSignUpLoginAndEmail = questions.reduce(
        (acc, { id, type }) => {
          if (
            includes(
              ["SignupForm::LoginQuestion", "SignupForm::AccountEmailQuestion"],
              type
            )
          ) {
            acc.push({
              id,
              type: type === "SignupForm::LoginQuestion" ? "login" : "email"
            });
          }
          return acc;
        },
        []
      );

      const response = await getSignupFormResponses(token, baseUrl);

      const preFillMissingResponses =
        questionIdAndTypesOfSignUpLoginAndEmail.reduce((acc, { id, type }) => {
          if (!response?.flattenedAnswers[id]?.value) {
            acc[id] = { value: profile[type] };
          }
          return acc;
        }, {});

      return { ...response?.flattenedAnswers, ...preFillMissingResponses };
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const updateSignupFormResponses = createAsyncThunk(
  "signupFormResponses/updateSignupFormResponses",
  async (_, { getState, rejectWithValue }) => {
    try {
      const { adapter, questions } = getState() as AppState;
      const { baseUrl } = adapter.adapter;
      const { answers } = questions;
      const { token } = fetchAuthToken(getState());

      const response = await changeSignupFormResponses(token, baseUrl, {
        answers
      });

      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
